import { Link } from 'react-router-dom';
import { aboutContent } from '@/mocks/filters';

const CATEGORY_LINKS = [
  { to: '/category/movie', label: '电影' },
  { to: '/category/tv', label: '电视剧' },
  { to: '/category/variety', label: '综艺' },
];

const QUICK_LINKS = [
  { to: '/', label: '首页' },
  { to: '/search', label: '影视搜索' },
  { to: '/about', label: '关于我们' },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="w-full max-w-content mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center font-heading font-black text-xl">
                蘑
              </span>
              <span className="font-heading font-black text-xl text-background-50">蘑菇视频</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80 max-w-md">
              蘑菇视频是一个综合影视资讯与视频观看平台，聚合电影、电视剧、综艺等多类型内容，让好内容被更快发现。
            </p>
            <p className="mt-4 text-xs text-background-300/60">
              本站内容均为演示数据，仅供产品展示与学习交流使用。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">影视分类</h3>
            <ul className="space-y-2.5">
              {CATEGORY_LINKS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快捷入口</h3>
            <ul className="space-y-2.5">
              {QUICK_LINKS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href={`mailto:${aboutContent.email}`}
                  className="text-sm text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  联系邮箱
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300/70">© 2026 蘑菇视频 Mushroom Video. 保留所有权利。</p>
          <p className="text-xs text-background-300/70">演示站点 · 仅供学习交流</p>
        </div>
      </div>
    </footer>
  );
}